import { render } from "./material-multiselect.vue?vue&type=template&id=9268abde&scoped=true&ts=true"
import script from "./material-multiselect.vue?vue&type=script&lang=ts"
export * from "./material-multiselect.vue?vue&type=script&lang=ts"

import "./material-multiselect.vue?vue&type=style&index=0&id=9268abde&scoped=true&lang=css"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9268abde"]])

export default __exports__